/**
 * @generated SignedSource<<81f22894ce74605451be58ab958e6b3e>>
 * @relayHash 7332ebf6c44dc80945d33164086421e8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8bd7af0e34b4068f7b5937012a6fa01e09d1234a930d63666730d898dc7dd3c1

import type { ConcreteRequest } from 'relay-runtime';
export type TemplateCardHomeViewGetTemplateInfoQuery$variables = {
  blueprintKey: string;
};
export type TemplateCardHomeViewGetTemplateInfoQuery$data = {
  readonly templateInfo: {
    readonly blueprintModuleCompleteKey: string | null | undefined;
    readonly contentBlueprintId: string | null | undefined;
    readonly darkModeIconURL: string | null | undefined;
    readonly iconURL: string | null | undefined;
    readonly itemModuleCompleteKey: string | null | undefined;
    readonly name: string | null | undefined;
    readonly templateType: string | null | undefined;
  } | null | undefined;
};
export type TemplateCardHomeViewGetTemplateInfoQuery = {
  response: TemplateCardHomeViewGetTemplateInfoQuery$data;
  variables: TemplateCardHomeViewGetTemplateInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "blueprintKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "blueprintKey"
      }
    ],
    "concreteType": "TemplateInfo",
    "kind": "LinkedField",
    "name": "templateInfo",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "name"
      },
      {
        "kind": "ScalarField",
        "name": "iconURL"
      },
      {
        "kind": "ScalarField",
        "name": "darkModeIconURL"
      },
      {
        "kind": "ScalarField",
        "name": "templateType"
      },
      {
        "kind": "ScalarField",
        "name": "contentBlueprintId"
      },
      {
        "kind": "ScalarField",
        "name": "blueprintModuleCompleteKey"
      },
      {
        "kind": "ScalarField",
        "name": "itemModuleCompleteKey"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TemplateCardHomeViewGetTemplateInfoQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TemplateCardHomeViewGetTemplateInfoQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7332ebf6c44dc80945d33164086421e8",
    "id": "8bd7af0e34b4068f7b5937012a6fa01e09d1234a930d63666730d898dc7dd3c1",
    "metadata": {},
    "name": "TemplateCardHomeViewGetTemplateInfoQuery",
    "operationKind": "query",
    "text": "query TemplateCardHomeViewGetTemplateInfoQuery($blueprintKey:ID!){templateInfo(id:$blueprintKey){name,iconURL,darkModeIconURL,templateType,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey}}"
  }
};
})();

(node as any).hash = "ec91cd9c58827fd518e9de2ec8ef39cf";

export default node;
